import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CONSENT_STEP, MOBILE_OPTIONS } from 'Pages/user'

type MobileUserState = {
	mobile_option: MOBILE_OPTIONS
	consent_step: CONSENT_STEP
}

const initialState: MobileUserState = {
	mobile_option: null,
	consent_step: null,
}

export namespace MobileUserNS {
	export type setMobileOption = PayloadAction<MOBILE_OPTIONS>
	export type setConsentStep = PayloadAction<CONSENT_STEP>
}

export const mobileUserSlice = createSlice({
	name: 'mobileUser',
	initialState,
	reducers: {
		setMobileOption: (state, action: MobileUserNS.setMobileOption) => {
			state.mobile_option = action.payload
		},
		clearMobileOption: (state) => {
			state.mobile_option = null
		},
		setConsentStep: (state, action: MobileUserNS.setConsentStep) => {
			state.consent_step = action.payload
		},
	},
})
